'use strict'

import { mapState, mapMutations } from 'vuex'
import Auth from '@/utils/Auth'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import AppMain from './AppMain'
import Login from '@/pages/user/userData/login'
import Register from '@/pages/user/userData/register'
import Forget from '@/pages/user/userData/forget'
import footerLeftBgImg from '@/assets/images/ad_bg_left.png'
import footerRightBgImg from '@/assets/images/ad_bg_right.png'
import './layout.scss'

export default {
    name: 'Layout',
    components: {
        Navbar,
        Sidebar,
        AppMain,
        Login,
        Register,
        Forget
    },
    data() {
        return {
            // 权限获取，登录: `login`, 注册: `register`，忘记密码: `forget`
            dialogType: ''
        }
    },
    computed: {
        ...mapState('common', ['authDialogType']),
        fixedHeader: function () {
            return true
        }
    },
    created() {
        // 只在未登录情况下在页面中弹出登录/注册/忘记密码框
        if (!Auth.isLogin()) {
            const unwatch = this.$watch('authDialogType', val => {
                if (this.dialogType !== val) {
                    this.dialogType = val
                }
            })

            this.$on('hook:beforeDestroy', () => {
                unwatch()
            })
        }
    },
    methods: {
        ...mapMutations('common', ['updateAuthDialogType']),
        toggleDialog(type) {
            this.dialogType = type
            this.updateAuthDialogType(type)
        }
    },
    render() {
        return (
            <div class='yt-container'>

                {/* 头部 */}
                <div class={`yt-header ${this.fixedHeader ? 'fixedHeader' : ''}`}>
                    <Navbar />
                </div>

                {/* 主体 */}
                <div class='yt-body'>

                    {/* 侧边菜单 */}
                    <Sidebar />

                    {/* 路由 */}
                    <AppMain />
                </div>

                {/* {
                    !Auth.isLogin() && (
                        <div class='yt-fixed-footer'>
                            <img src={footerLeftBgImg} style='width: 68px; height: 74px;' />
                            <div class='footer-content'>
                                <div class='left'>
                                    <el-tooltip placement='top'>
                                        <el-image class='qrcode' src='xx' style='width: 200px; height: 200px;' slot='content' />
                                        <el-image class='qrcode-thumb' src='xx' />
                                    </el-tooltip>
                                    <div class='text'>扫码获取<span class='strong'>30</span>天免费试用，额外再送《不动产行业报告》，《不动产企业研报》</div>
                                </div>
                                <div class='right'>
                                    <div class='btn btn-login' onClick={() => this.toggleDialog('login')}>登录</div>
                                    <div class='btn btn-register' onClick={() => this.toggleDialog('register')}>注册</div>
                                </div>
                            </div>
                            <img src={footerRightBgImg} style='width: 169px; height: 74px;' />
                        </div>
                    )
                } */}

                {
                    this.dialogType === 'login' && (
                        <Login
                            onClose={() => this.toggleDialog('')}
                            onRegister={() => this.toggleDialog('register')}
                            onForget={() => this.toggleDialog('forget')}
                            dialogVisible
                            withoutAuth
                        />
                    )
                }

                {
                    this.dialogType === 'register' && (
                        <Register
                            onClose={() => this.toggleDialog('')}
                            onToLogin={() => this.toggleDialog('login')}
                            dialogVisible
                            withoutAuth
                        />
                    )
                }

                {
                    this.dialogType === 'forget' && (
                        <Forget
                            onClose={() => this.toggleDialog('')}
                            onToLogin={() => this.toggleDialog('login')}
                            dialogVisible
                            withoutAuth
                        />
                    )
                }

            </div>
        )
    }
}
